import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { getColorBackground, getOverviewGradient } from "./colorUtils";
import "./ColorSelector.scss";

const ColorSelector = ({ colorSelector }) => {
    const [groups, setGroups] = useState(colorSelector.groups);
    const [portalTarget, setPortalTarget] = useState(null);

    const resolvePortalTarget = () => {
        const targetId = window.isMobIsipadIsPotrait ? "colorContainerMobile" : "colorContainer";
        const el = document.getElementById(targetId);
        setPortalTarget(el || null);
    };

    useEffect(() => {
        resolvePortalTarget();

        const handleChange = () => {
            setTimeout(resolvePortalTarget, 600);
        };

        window.addEventListener("orientationchange", handleChange);
        window.addEventListener("resize", handleChange);

        return () => {
            window.removeEventListener("orientationchange", handleChange);
            window.removeEventListener("resize", handleChange);
        };
    }, []);

    // 🔥 NEW — sync "keys" active circle with sequence.js keyboard swap animation
    useEffect(() => {
        const syncKeyColorFromAnimation = (e) => {
            const colorName = e?.detail; // e.g. "RadiantCoral"
            if (!colorName) return;

            setGroups((prevGroups) =>
                prevGroups.map((group) => {
                    if (group.id !== "keys") return group;
                    const matchedColor = group.colors.find((c) => c.name === colorName);
                    if (!matchedColor) return group;
                    return { ...group, selected: matchedColor.id };
                })
            );
        };

        window.addEventListener("KeyColorChange", syncKeyColorFromAnimation);
        return () => window.removeEventListener("KeyColorChange", syncKeyColorFromAnimation);
    }, []);

    if (!colorSelector.visible) return null;
    if (!portalTarget || !document.body.contains(portalTarget)) return null;

    const handleColorClick = (groupId, color) => {
        const updatedGroups = groups.map((currentGroup) => {
            if (currentGroup.id === groupId) {
                return { ...currentGroup, selected: color.id };
            }
            return currentGroup;
        });
        setGroups(updatedGroups);

        if (groupId === "keys") {
            clearTimeout(window.keyboardTimeout);
            clearTimeout(window.keyboardIdleTimeout);
            window.keyboardTimeout = null;

            window.keyboardIdleTimeout = setTimeout(() => {
                if (window.selectedConfig.currentSelectedHotspot === "Customizablekeys") {
                    window.keyboardSwapAnim();
                }
            }, 10000);
        }
        let sequenceName = color.sequenceName;
        if (sequenceName) {
            window.scene.applySequence(window[sequenceName]);
            if (groupId === 'body') {
                window.selectedConfig.selectedBodyColorSequence = sequenceName;
            } else {
                window.selectedConfig.selectedKeyColorSequence = sequenceName;
            }
        }
    };

    return ReactDOM.createPortal(
        <div id="colorSelector">
            {groups.map((group) => (
                <div className={`color-column ${group.id}`} key={group.id}>
                    <div className="color-title">
                        <h3>{group.title}</h3>
                    </div>
                    <div className="color-list">
                        {group.colors.map((color) => (
                            <div
                                key={color.id}
                                className={`color-circle ${group.selected === color.id ? "active" : ""}`}
                                onClick={() => handleColorClick(group.id, color)}
                            >
                                <img
                                    src={color.icon}
                                    alt={color.sequenceName}
                                    className="color-icon"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>,
        portalTarget
    );
};

export default ColorSelector;